import { Component, Host, h, Prop, Watch } from '@stencil/core';

@Component({
  tag: 'sy-avatar',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class Avatar {
  /**
   * Sets avatar shape to circle.
   */
  @Prop({ reflect: true }) rounded = false;

  /**
   * Sets avatar size to small (32x32).
   */
  @Prop({ reflect: true }) small = false;

  /**
   * Sets avatar background-image (URL).
   */
  @Prop() image: string;

  /**
   * Sets a text its shown if there is no `image`.
   * Must be a string with same size of `initialsSize`.
   */
  @Prop() initials: string;

  /**
   * Sets `initials` string characters number (min: 1, max: 3)
   */
  @Prop({ reflect: true, mutable: true }) initialsSize = 2;

  private shownInitials = '';

  @Watch('initials')
  initialsWatcher(): void {
    this.shownInitials = this.initials;

    if (this.initials && this.initials.length > this.initialsSize) {
      this.shownInitials = this.initials.slice(0, this.initialsSize);
    }
  }

  @Watch('initialsSize')
  initialsSizeWatcher(): void {
    if (this.initialsSize < 1) {
      this.initialsSize = 1;
    }

    if (this.initialsSize > 3) {
      this.initialsSize = 3;
    }

    this.initialsWatcher();
  }

  private showInitials(): boolean {
    if (!this.shownInitials || this.image) {
      return false;
    }

    return true;
  }

  componentWillLoad() {
    this.initialsSizeWatcher();
  }

  render() {
    const style = {};

    if (this.image) {
      style['background-image'] = `url(${this.image})`;
    }

    return <Host style={style}>{this.showInitials() ? this.shownInitials : ''}</Host>;
  }
}
